import React from 'react'
import { Paragraph, Text } from 'theme-ui'
import { ExternalLink } from 'ui'
import { CONTROLDText } from 'ui/CONTROLD'
import { FAQItem } from 'components/FrequentlyAskedQuestions'

const frequentlyAskedQuestionsStyles = {
  textDecoration: 'underline',
  color: 'greenApple',
}

export const frequentlyAskedQuestions: FAQItem[] = [
  {
    question: `Can malware blocking affect my employees' browsing experience?`,
    answer: (
      <Text>
        <Paragraph>
          Not at all. Malware blocking is designed to operate quietly in the background, ensuring
          employees remain safe without any noticeable impact on browsing speed or experience.
        </Paragraph>
        <br />
        <Paragraph>
          Malware blocking tools prevent access to malicious sites and harmful content without
          interfering with legitimate browsing. If an unsafe website is detected, employees are
          simply redirected away, ensuring their devices and data stay secure without causing
          frustration.
        </Paragraph>
        <br />
        <Paragraph>
          Modern malware protection is optimized to scan traffic efficiently, meaning that browsing
          speeds are virtually unaffected. Employees can continue working without noticing any
          slowdowns, even as threats are neutralized in real-time.
        </Paragraph>
        <br />
        <Paragraph>
          What’s more, tools like {CONTROLDText} are designed to minimize false positives, so
          legitimate websites and downloads are rarely blocked. If a file is flagged, it&apos;s
          usually because it&apos;s genuinely risky, protecting the business from potential threats.
        </Paragraph>
      </Text>
    ),
  },
  {
    question: 'How do we know if a website is blocked because of malware?',
    answer: (
      <Text>
        <Paragraph>
          If an employee attempts to visit a site flagged for distributing malware, they&apos;ll
          receive a warning message informing them that the site has been blocked to protect your
          business.
        </Paragraph>
        <br />
        <Paragraph>
          This keeps security transparent and easy to navigate without adding complexity to their
          workday.
        </Paragraph>
      </Text>
    ),
  },
  {
    question: 'Is malware blocking enough to protect our business devices from all threats?',
    answer: (
      <Text>
        <Paragraph>
          While malware blocking is an essential line of defense, it&apos;s best used in combination
          with other security measures such as antivirus software, a secure firewall, and safe
          browsing habits.
        </Paragraph>
        <br />
        <Paragraph>
          For example, malware blocking tools do not fully protect against phishing or social
          engineering attacks, which trick users into giving up sensitive information like passwords
          or financial data. Email filters, anti-phishing solutions, and employee training on
          recognizing phishing attempts are essential to complement malware blocking.
        </Paragraph>
        <br />
        <Paragraph>
          Business devices are also vulnerable to attacks that exploit weaknesses in operating
          systems, applications, or outdated software. Regular patch management, system updates, and
          vulnerability scanning are critical steps in preventing these types of attacks.
        </Paragraph>
        <br />
        <Paragraph>
          In the event of a security breach or malware attack, data encryption and regular backups
          ensure that sensitive business data remains protected and can be restored quickly. Malware
          blocking alone cannot prevent data breaches or ransomware attacks, but encryption and
          backup systems can mitigate the damage.
        </Paragraph>
      </Text>
    ),
  },
  {
    question: `How frequently is ${CONTROLDText}’s threat database updated?`,
    answer: (
      <Text>
        Our threat database is updated in real-time to ensure your business always has the latest
        protection against new and evolving threats.
      </Text>
    ),
  },
  {
    question: `Can I test out the service before buying a plan?`,
    answer: (
      <Text>
        {CONTROLDText} offers a risk-free trial for all organizations -{' '}
        <ExternalLink
          sx={{
            ...frequentlyAskedQuestionsStyles,
          }}
          to={`https://controld.com/onboard`}
        >
          sign up with your business email
        </ExternalLink>{' '}
        and test the service safely and securely (no credit card required).
      </Text>
    ),
  },
  {
    question: 'I have more questions. Can I speak with a human?',
    answer: (
      <Text>
        Feel free to{' '}
        <ExternalLink
          sx={{
            ...frequentlyAskedQuestionsStyles,
          }}
          to={`https://controld.com/demo`}
        >
          book a demo
        </ExternalLink>{' '}
        with a member of our team, who would be happy to assist with any additional queries or
        concerns.
      </Text>
    ),
  },
]
